import { Fragment } from 'react';
import styles from '../kyc-intelligence.module.css';

function AlternateMobileData({details}) {

    return (<>
        <div className={styles['basic-report-box']}>
            <h2>Alternate mobile data</h2>
            {details?.details?.map((item, index) => {

                return (
                    <Fragment key={index}>
                        <h3>Phone number - {item?.mobileNumber}</h3>
                        <h4>Aadhaar link</h4>
                        <div className={styles['basic-report-details']}>
                            <div>
                                <span>Status: </span>
                                {item?.aadhaarLink?.status ? String(item?.aadhaarLink?.status) : 'false'}
                            </div>
                            <div>
                                <span>Message: </span>
                                {item?.aadhaarLink?.message || '-'}
                            </div>
                        </div>
                        <h4>Address</h4>
                        {item?.address?.result?.map((addressItem, addressIndex) => (
                            <Fragment key={addressIndex}>
                                <h5>Result {addressIndex+1}</h5>
                                <div className={styles['basic-report-details']}>
                                    <div>
                                        <span>First name: </span>
                                        {addressItem?.first_name || '-'}
                                    </div>
                                    <div>
                                        <span>Last name: </span>
                                        {addressItem?.last_name || '-'}
                                    </div>
                                    <div>
                                        <span>Email: </span>
                                        {addressItem?.email || '-'}
                                    </div>
                                    <div>
                                        <span>ISD code: </span>
                                        {addressItem?.isd_code || '-'}
                                    </div>
                                    <div>
                                        <span>Line 1: </span>
                                        {addressItem?.line1 || '-'}
                                    </div>
                                    <div>
                                        <span>Line 2: </span>
                                        {addressItem?.line2 || '-'}
                                    </div>
                                    <div>
                                        <span>City: </span>
                                        {addressItem?.city || '-'}
                                    </div>
                                    <div>
                                        <span>State: </span>
                                        {addressItem?.state || '-'}
                                    </div>
                                    <div>
                                        <span>State code: </span>
                                        {addressItem?.state_code || '-'}
                                    </div>
                                    <div>
                                        <span>Country: </span>
                                        {addressItem?.country || '-'}
                                    </div>
                                    <div>
                                        <span>Country code: </span>
                                        {addressItem?.country_code || '-'}
                                    </div>
                                    <div>
                                        <span>Pincode: </span>
                                        {addressItem?.pincode || '-'}
                                    </div>
                                    <div>
                                        <span>Last delivery date: </span>
                                        {addressItem?.last_delivery_date || '-'}
                                    </div>
                                </div>
                            </Fragment>
                        ))}
                        <h4>Age</h4>
                        <div className={styles['basic-report-details']}>
                            <div>
                                <span>Has porting history: </span>
                                {item?.age?.result?.has_porting_history || '-'}
                            </div>
                            <div>
                                <span>Mobile age: </span>
                                {item?.age?.result?.mobile_age || '-'}
                            </div>
                            <div>
                                <span>Is number active: </span>
                                {item?.age?.result?.is_number_active || '-'}
                            </div>
                            <div>
                                <span>Is number valid: </span>
                                {item?.age?.result?.is_number_valid || '-'}
                            </div>
                            <div>
                                <span>Ported region: </span>
                                {item?.age?.result?.ported_region || '-'}
                            </div>
                            <div>
                                <span>Current ported telecom provider: </span>
                                {item?.age?.result?.current_ported_telecom_provider || '-'}
                            </div>
                            <div>
                                <span>Original region: </span>
                                {item?.age?.result?.original_region || '-'}
                            </div>
                            <div>
                                <span>Original telecom provider: </span>
                                {item?.age?.result?.original_telecom_provider || '-'}
                            </div>
                            <div>
                                <span>Roaming: </span>
                                {item?.age?.result?.roaming || '-'}
                            </div>
                        </div>
                        <h4>Identity</h4>
                        <h5>Address info</h5>
                        {item?.identity?.result?.address_info?.map((addressItem, addressIndex) => (
                            <Fragment key={addressIndex}>
                                <h6>Result {addressIndex+1}</h6>
                                <div className={styles['basic-report-details']}>
                                    <div>
                                        <span>Address: </span>
                                        {addressItem?.address || '-'}
                                    </div>
                                    <div>
                                        <span>Postal: </span>
                                        {addressItem?.postal || '-'}
                                    </div>
                                    <div>
                                        <span>Reported date: </span>
                                        {addressItem?.reported_date || '-'}
                                    </div>
                                    <div>
                                        <span>State: </span>
                                        {addressItem?.state || '-'}
                                    </div>
                                    <div>
                                        <span>Type: </span>
                                        {addressItem?.type || '-'}
                                    </div>
                                </div>
                            </Fragment>
                        ))}
                        <br/>
                        <h5>Email info</h5>
                        {item?.identity?.result?.email_info?.map((emailItem, emailIndex) => (
                            <Fragment key={emailIndex}>
                                <h6>Result {emailIndex+1}</h6>
                                <div className={styles['basic-report-details']}>
                                    <div>
                                        <span>Email address: </span>
                                        {emailItem?.email_address || '-'}
                                    </div>
                                    <div>
                                        <span>Reported date: </span>
                                        {emailItem?.reported_date || '-'}
                                    </div>
                                </div>
                            </Fragment>
                        ))}
                        <br/>
                        <h5>Identity info</h5>
                        <h6>Aadhaar number</h6>
                        <div className={styles['basic-report-details']}>
                            {
                                item?.identity?.result?.identity_info?.aadhaar_number?.length===0
                                ?<div> No details found </div>
                                :item?.identity?.result?.identity_info?.aadhaar_number?.map((numberItem, numberIndex) => (
                                    <div key={numberIndex}>
                                        <span>{numberIndex+1}: </span>
                                        {numberItem?.id_number || '-'}
                                    </div>
                                ))
                            }
                        </div>
                        <h6>Driving license</h6>
                        <div className={styles['basic-report-details']}>
                            {
                                item?.identity?.result?.identity_info?.driving_license?.length===0
                                ?<div> No details found </div>
                                :item?.identity?.result?.identity_info?.driving_license?.map((numberItem, numberIndex) => (
                                    <div key={numberIndex}>
                                        <span>{numberIndex+1}: </span>
                                        {numberItem?.id_number || '-'}
                                    </div>
                                ))
                            }
                        </div>



                        <h6>Other id</h6>
                        <div className={styles['basic-report-details']}>
                            {
                                item?.identity?.result?.identity_info?.other_id?.length===0
                                ?<div> No details found </div>
                                :item?.identity?.result?.identity_info?.other_id?.map((numberItem, numberIndex) => (
                                    <div key={numberIndex}>
                                        <span>{numberIndex+1}: </span>
                                        {numberItem?.id_number || '-'}
                                    </div>
                                ))
                            }
                        </div>
                        <h6>PAN number</h6>
                        <div className={styles['basic-report-details']}>
                            {
                                item?.identity?.result?.identity_info?.pan_number?.length===0
                                ?<div> No details found </div>
                                :item?.identity?.result?.identity_info?.pan_number?.map((numberItem, numberIndex) => (
                                    <div key={numberIndex}>
                                        <span>{numberIndex+1}: </span>
                                        {numberItem?.id_number || '-'}
                                    </div>
                                ))
                            }
                        </div>
                        <h6>Passport number</h6>
                        <div className={styles['basic-report-details']}>
                            {
                                item?.identity?.result?.identity_info?.passport_number?.length===0
                                ?<div> No details found </div>
                                :item?.identity?.result?.identity_info?.passport_number?.map((numberItem, numberIndex) => (
                                    <div key={numberIndex}>
                                        <span>{numberIndex+1}: </span>
                                        {numberItem?.id_number || '-'}
                                    </div>
                                ))
                            }
                        </div>
                        <h6>Ration card</h6>
                        <div className={styles['basic-report-details']}>
                            {
                                item?.identity?.result?.identity_info?.ration_card?.length===0
                                ?<div> No details found </div>
                                :item?.identity?.result?.identity_info?.ration_card?.map((numberItem, numberIndex) => (
                                    <div key={numberIndex}>
                                        <span>{numberIndex+1}: </span>
                                        {numberItem?.id_number || '-'}
                                    </div>
                                ))
                            }
                        </div>
                        <h6>Voter id</h6>
                        <div className={styles['basic-report-details']}>
                            {
                                item?.identity?.result?.identity_info?.voter_id?.length===0
                                ?<div> No details found </div>
                                :item?.identity?.result?.identity_info?.voter_id?.map((numberItem, numberIndex) => (
                                    <div key={numberIndex}>
                                        <span>{numberIndex+1}: </span>
                                        {numberItem?.id_number || '-'}
                                    </div>
                                ))
                            }
                        </div>
                        <br/>
                        <h5>Personal info</h5>
                        <div className={styles['basic-report-details']}>
                            <div>
                                <span>Age: </span>
                                {item?.identity?.result?.personal_info?.age || '-'}
                            </div>
                            <div>
                                <span>DOB: </span>
                                {item?.identity?.result?.personal_info?.dob || '-'}
                            </div>
                            <div>
                                <span>Full name: </span>
                                {item?.identity?.result?.personal_info?.full_name || '-'}
                            </div>
                            <div>
                                <span>Gender: </span>
                                {item?.identity?.result?.personal_info?.gender || '-'}
                            </div>
                            <div>
                                <span>Occupation: </span>
                                {item?.identity?.result?.personal_info?.occupation || '-'}
                            </div>
                            <div>
                                <span>Total income: </span>
                                {item?.identity?.result?.personal_info?.total_income || '-'}
                            </div>
                        </div>
                        <br/>
                        <h5>Phone info</h5>
                        {item?.identity?.result?.phone_info?.map((phoneItem, phoneIndex) => (
                            <Fragment key={phoneIndex}>
                                <h6>Result {phoneIndex+1}</h6>
                                <div className={styles['basic-report-details']}>
                                    <div>
                                        <span>Number: </span>
                                        {phoneItem?.number || '-'}
                                    </div>
                                    <div>
                                        <span>Reported date: </span>
                                        {phoneItem?.reported_date || '-'}
                                    </div>
                                    <div>
                                        <span>Type code: </span>
                                        {phoneItem?.type_code || '-'}
                                    </div>
                                </div>
                            </Fragment>
                        ))}
                        <h4>RC details</h4>
                        <div className={styles['basic-report-details']}>
                            {
                                item?.rcDetails?.result?.length===0||item?.rcDetails?.result?.length===undefined
                                ?<div> No details found </div>
                                :item?.rcDetails?.result?.map((rcItem, rcIndex) => (
                                    <div key={rcIndex}> <span>{rcIndex+1}: </span>{rcItem} </div>
                                ))
                            }
                        </div>
                    </Fragment>
                )
            })}
        </div>
    </>);
}

export default AlternateMobileData;